import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ErrorText from './Basic/ErrorText';
import ElevatedSelectControlled from './Basic/ElevatedSelectControlled';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { useEffect } from 'react';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    paddingTop: 24,

    '& .container': {
      display: 'flex',
      alignItems: 'center',
    },

    '& .label': {
      position: 'absolute',
      fontSize: '0.9rem',
      transform: 'translate(0, -24px)',
      fontWeight: 400,
      color: 'inherit',
    },

    '& .MuiFormControl-root': {
      marginTop: 0,
    },

    '& .select': {
      flex: 1,
      marginRight: 10,

      '&--seconds': {
        marginRight: 0,
      },

      [theme.breakpoints.up('lg')]: {
        maxWidth: 76,
      },
    },

    '& .error': {
      marginTop: 5,
    },

    '& .clear-btn': {
      marginLeft: 5,
      '& .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
  },
}));

const hours = [];
const minutes = [];

const digitToStringFormat = (digit) => (digit <= 9 ? `0${digit}` : `${digit}`);

for (let i = 9; i <= 15; i++) {
  const fornattedDigit = digitToStringFormat(i);
  hours.push({
    value: fornattedDigit,
    label: fornattedDigit,
  });
}

for (let i = 0; i < 60; i++) {
  const fornattedDigit = digitToStringFormat(i);
  minutes.push({
    value: fornattedDigit,
    label: fornattedDigit,
  });
}

function TimeSelectorGeneral({
  value,
  label,
  name,
  error,
  helperText,
  disabled,
  onChange = () => {},
  onClear = () => {},
  showClearButton = false,
  blankValue = false,
}) {
  const classes = useStyles();
  const [
    hoursValueRaw = blankValue ? '' : '09',
    minutesValueRaw = blankValue ? '' : '00',
    secondsValueRaw = blankValue ? '' : '00',
  ] = value.split(':');

  const [hoursValue, setHoursValue] = useState(hoursValueRaw);
  const [minutesValue, setMinutesValue] = useState(minutesValueRaw);
  const [secondsValue, setSecondsValue] = useState(secondsValueRaw);

  useEffect(() => {
    const [
      hoursValueRaw = blankValue ? '' : '09',
      minutesValueRaw = blankValue ? '' : '00',
      secondsValueRaw = blankValue ? '' : '00',
    ] = value.split(':');

    setHoursValue(hoursValueRaw);
    setMinutesValue(minutesValueRaw);
    setSecondsValue(secondsValueRaw);
  }, [value, blankValue]);

  const onChangeHours = (val) => {
    setHoursValue(val);
  };

  const onChangeMinutes = (val) => {
    setMinutesValue(val);
  };

  const onChangeSeconds = (val) => {
    setSecondsValue(val);
  };

  const onBlur = () => {
    onChange(`${hoursValue}:${minutesValue}:${secondsValue}`);
  };

  return (
    <div className={classes.root}>
      <label className="label">{label}</label>
      <div className="container">
        <div className="select select--hours">
          <ElevatedSelectControlled
            searchable
            disableClearable
            placeholder="HH"
            value={hoursValue}
            name={`${name}_hh`}
            disabled={disabled}
            options={hours}
            onChange={onChangeHours}
            onBlur={onBlur}
          />
        </div>
        <div className="select select--minutes">
          <ElevatedSelectControlled
            searchable
            disableClearable
            placeholder="MM"
            value={minutesValue}
            name={`${name}_mm`}
            disabled={disabled}
            options={minutes}
            onChange={onChangeMinutes}
            onBlur={onBlur}
          />
        </div>
        <div className="select select--seconds">
          <ElevatedSelectControlled
            searchable
            disableClearable
            placeholder="SS"
            value={secondsValue}
            name={`${name}_ss`}
            disabled={disabled}
            options={minutes}
            onChange={onChangeSeconds}
            onBlur={onBlur}
          />
        </div>
        {showClearButton && (
          <div className="clear-btn">
            <IconButton onClick={onClear} size="small" disabled={disabled}>
              <CloseIcon />
            </IconButton>
          </div>
        )}
      </div>
      {error && (
        <div className="error">
          <ErrorText noMargin error={error} helperText={helperText} />
        </div>
      )}
    </div>
  );
}

TimeSelectorGeneral.defaultProps = {
  disabled: false,
  error: false,
  helperText: '',
};

TimeSelectorGeneral.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

export default TimeSelectorGeneral;
